module.exports = __webpack_public_path__ + "img/Signup-Learning.b6ae8aae.gif";